import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

import FleximodoParkinglocationsTable from '../components/FleximodoParkinglocationsTable';
import FleximodoParkinglocationsForm from '../components/FleximodoParkinglocationsForm';

import FleximodoParkinglocationsModel from '../components/FleximodoParkinglocationsModel';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Icon, DatePicker, message } from 'antd';

class FleximodoParkinglocationsScreen extends Component {

  state = {
    dataLoading: true,
    dataAll: [],
    data: [],
    fleximodoParkinglocationsFormModalVisible: false,
  }

  componentWillMount() {
    this.loadData();
  }

  loadData() {
    this.setState({
      dataLoading: true
    });
    FleximodoParkinglocationsModel.getAll()
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });
      })
      .catch(() => {
        message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
        this.setState({
          dataLoading: false,
        });
      });
  }


  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff' }}>
          <h2>Fleximodo - Seznam lokalit</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={8}>
              </Col>
              <Col span={8} offset={8} style={{ textAlign: 'right' }}>
                <Button type="default" onClick={() => { this.loadData() }} style={{ marginRight: 10 }}><Icon type="sync" /></Button>
                {UserModel.isInRoles(['ADMIN', 'FLEXIMODO_LOCATIONS_WRITE'])
                  ? <Button type="default" onClick={() => { this.setState({ fleximodoParkinglocationsFormModalVisible: true }) }}>Nová lokalita</Button>
                  : null}
              </Col>
            </Row>
          </div>
          <FleximodoParkinglocationsForm
            type="modal"
            modalVisible={this.state.fleximodoParkinglocationsFormModalVisible}
            onModalCancel={() => { this.setState({ fleximodoParkinglocationsFormModalVisible: false }) }}
            onSuccess={(form, values) => {
              FleximodoParkinglocationsModel.create(values)
                .then(() => {
                  message.success("Lokalita byla vložena!");
                  form.resetFields();
                  this.loadData();
                })
                .catch((err) => {
                  message.warning('Data se nepodařilo uložit. Prosím kontaktujte správce systému!');
                });
            }} />
          <FleximodoParkinglocationsTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onDetailRow={(record) => {
            }}
            onRemoveRow={(carParkCode) => {
              FleximodoParkinglocationsModel.remove(carParkCode)
                .then(() => {
                  this.loadData();
                });
            }} />
        </div>
      </Layout.Content>
    );
  }
}

export default FleximodoParkinglocationsScreen;



// WEBPACK FOOTER //
// ./src/screens/FleximodoParkinglocationsScreen.js